import { Signup } from 'modules/Auth/components/Signup/Signup';
import { GetServerSideProps } from 'next';
import { getDefaultServerProps } from 'server/getDefaultServerProps';

export default function SignupPage({ siteKey, defaultCaptchaToken }: { siteKey?: string; defaultCaptchaToken?: string }): JSX.Element | null {
  return <Signup siteKey={siteKey} defaultCaptchaToken={defaultCaptchaToken} />;
}

// Disable automated next.js optimisation because of dynamic recaptcha key for env
export const getServerSideProps: GetServerSideProps = async ({ params, req, res }) => {
  if (process.env.NEXT_PUBLIC_SIGN_UP_DISABLED === 'true') {
    return {
      redirect: {
        destination: '/404',
        permanent: false,
      },
    };
  }

  const defaultServerProps = await getDefaultServerProps({ params, req, res });

  return {
    props: {
      ...defaultServerProps,
      trackEventProps: {
        eventName: 'SignUp Page Viewed',
      },
      siteKey: process.env.NEXT_PUBLIC_GOOGLE_RECAPTCHA_SITE_KEY || null,
      defaultCaptchaToken: process.env.NEXT_PUBLIC_DEFAULT_CAPTCHA_TOKEN || null,
    },
  };
};
